






















































































































import { defineComponent, reactive, toRefs, ref, onMounted, watch, computed, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http"
import moment from 'moment'
import { BModal, BCarousel } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue"
import SumupResultRankTab from "../../components/SumupResultRankTab.vue"
import { SumupGroup, RankResult, SumupTotalAll, SearchCondtion } from "../../modules/teacher/PracticeSumupResultRankListCurriculum"

export interface Data {
  sumup_group_id: string
  curriculum_id: string
  condition: SearchCondtion
  sumupGroup: SumupGroup
  rankResults: RankResult[]
  filteredRankResults: RankResult[]
  sumupTotalAll: SumupTotalAll
  additionTarget: RankResult
  fields: any[]
  isAllChecked: boolean
  previewActive: boolean,
  carouselPageIdx: number
  windowHeight: number
  modalTarget: RankResult
  isShowCarousel: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-result-rank-tab": SumupResultRankTab,
    "alert-area": AlertArea,
  },
  setup(_, context){

    const additionModalRef = ref<InstanceType<typeof BModal>>();
    const assessmentModalRef = ref<InstanceType<typeof BModal>>();
    const imageModalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      curriculum_id: "",
      condition: new SearchCondtion(),
      sumupGroup: null,
      rankResults: [],
      filteredRankResults: [],
      sumupTotalAll: null,
      additionTarget: null,
      fields: [],
      isAllChecked: false,
      previewActive: false,
      carouselPageIdx: 0,
      windowHeight: 0,
      modalTarget: null,
      isShowCarousel: false,
      errors: new Array<string>()
    });

    /************************************************************
     * 採点結果画像モーダル表示
     ************************************************************/

    const previewImage = async (rankResult: RankResult) => {
      if(!rankResult.isDownloaded){
        await downloadResultImage(rankResult);
      }

      state.modalTarget = rankResult;
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      imageModalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 採点結果画像ダウンロード
     ************************************************************/

    const downloadResultImage = async (rankResult: RankResult) => {
      context.root.$store.dispatch("showOverlay");
        await http.get(`/api/teacher/practice_sumup_result_rank_list_curriculum/download_result_image/${rankResult.sheet_group_key}/${rankResult.student_no_character}`).then(response => {
          rankResult.base64Images = response.data.base64_images;
          rankResult.isDownloaded = true;
          const r = state.rankResults.filter(x => x.practice_examinee_id == rankResult.practice_examinee_id)[0];
          r.base64Images = response.data.base64_images;
          r.isDownloaded = true;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.modalTarget.base64Images.length -1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.modalTarget.base64Images.length){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevResultImageModal = async () => {
      const idx = state.filteredRankResults.indexOf(state.modalTarget);
      
      if(idx > 0){
        if(!state.filteredRankResults[idx - 1].isDownloaded){
          await downloadResultImage(state.filteredRankResults[idx - 1]);
        }
        state.modalTarget = state.filteredRankResults[idx - 1];
        carouselRef.value.setSlide(state.carouselPageIdx);
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextResultImageModal = async () => {
      const idx = state.filteredRankResults.indexOf(state.modalTarget);
      
      if(idx < state.filteredRankResults.length - 1){
        if(!state.filteredRankResults[idx + 1].isDownloaded){
          await downloadResultImage(state.filteredRankResults[idx + 1]);
        }
        state.modalTarget = state.filteredRankResults[idx + 1];
        carouselRef.value.setSlide(state.carouselPageIdx);
      }
    };

    /************************************************************
     * 画面リサイズ時のウィンドウの高さを保持
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    /******************************
     * 備考モーダル表示
     ******************************/

    const showAdditionModal = (target: RankResult) => {
      state.additionTarget = target;
      additionModalRef.value.show();
    }

    /******************************
     * 検索
     ******************************/

    const search = () => {
      let filteredRankResults = state.rankResults.map(x => x);
      if(state.condition.student_no_character){
        filteredRankResults = state.rankResults.filter(x => x.student_no_character == state.condition.student_no_character);
      }
      if(state.condition.student_name){
        filteredRankResults = filteredRankResults.filter(x => x.student_name.includes(state.condition.student_name));
      }
      if(state.condition.applied_type){
        filteredRankResults = state.rankResults.filter(x => x.applied_type == state.condition.applied_type);
      }
      state.filteredRankResults = filteredRankResults;
    }

    /******************************
     * クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondtion();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return `${value}位`;
    }

    /******************************
     * 答案DL列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllChecked, (newVal, oldVal) => {
      state.rankResults.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * ダウンロード
     ******************************/

    const download = async () => {

      const studentNoCharacters = state.rankResults.filter(x => x.isSelected).map(x => x.student_no_character);
      if(studentNoCharacters.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("答案をダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/sumup_result_rank_list_curriculum/download_pdf/${state.sumup_group_id}/${state.curriculum_id}/${studentNoCharacters}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sumupGroup.name}_${context.root.$store.getters.getCurriculumNameById(state.curriculum_id)}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 判定設定モーダル表示
     ******************************/

    const showAssessmentModal = () => {
      assessmentModalRef.value.show();
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id == null ? "" : context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/practice_sumup_result_rank_list_curriculum?sumup_group_id=${state.sumup_group_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.rankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.filteredRankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.sumupTotalAll = new SumupTotalAll(response.data.sumup_total_all);
        state.additionTarget = state.rankResults[0];
        state.modalTarget = state.rankResults[0];

        state.fields = [
          {key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'},
          {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
          {key: "cram_school_name", label: "塾名", sortable: true, class: 'text-center b-table-th-td'},
          {key: "cram_room_name", label: "教室名", sortable: true, class: 'text-center b-table-th-td'},
          {key: "applied_type_name", label: "志願種別", sortable: true, class: 'text-center b-table-th-td'},
          {key: "result_image", label: "答案", sortable: false, class: 'text-center b-table-th-td'},
          {key: "score", label: "得点", sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'},
          {key: "rank", label: "順位", sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'},
          {key: "std_score", label: "偏差値", sortable: true, class: 'text-center b-table-th-td'},
        ]
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      additionModalRef,
      assessmentModalRef,
      imageModalRef,
      carouselRef,
      convertExecDate,
      scoreFormatter,
      rankFormatter,
      showAdditionModal,
      download,
      showAssessmentModal,
      search,
      clearCondition,
      previewImage,
      carouselPrev,
      carouselNext,
      adjustHeight,
      changePrevResultImageModal,
      changeNextResultImageModal
    };
  }
});
